function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 2C8.96243 2 6.5 4.46243 6.5 7.5C6.5 9.79086 9.6283 15.5086 11.1663 18.1812C11.5406 18.8317 12.4594 18.8317 12.8337 18.1812C14.3717 15.5086 17.5 9.79086 17.5 7.5C17.5 4.46243 15.0376 2 12 2Z",
  stroke: "currentColor",
  strokeWidth: 2
});

var _ref3 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 12.0008,
  cy: 7.50029,
  rx: 2.2,
  ry: 2.2,
  fill: "currentColor"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M18.6548 15.0656C18.1387 14.8689 17.5609 15.1278 17.3642 15.6439C17.1676 16.16 17.4265 16.7378 17.9426 16.9344L18.6548 15.0656ZM6.05741 16.9344C6.57349 16.7378 6.83242 16.16 6.63576 15.6439C6.43909 15.1278 5.86129 14.8689 5.34521 15.0656L6.05741 16.9344ZM20 18.5C20 18.6089 19.9472 18.8216 19.6159 19.1262C19.2838 19.4316 18.7479 19.7526 18.0015 20.0429C16.515 20.6209 14.3935 21 12 21V23C14.577 23 16.9555 22.5956 18.7264 21.9069C19.6087 21.5638 20.3909 21.1306 20.9696 20.5985C21.5491 20.0656 22 19.3576 22 18.5H20ZM12 21C9.60648 21 7.48496 20.6209 5.99849 20.0429C5.25207 19.7526 4.71624 19.4316 4.3841 19.1262C4.0528 18.8216 4 18.6089 4 18.5H2C2 19.3576 2.45088 20.0656 3.03043 20.5985C3.60913 21.1306 4.39133 21.5638 5.27359 21.9069C7.04448 22.5956 9.42296 23 12 23V21ZM17.9426 16.9344C18.7083 17.2262 19.2601 17.5512 19.603 17.862C19.9457 18.1725 20 18.3898 20 18.5H22C22 17.6308 21.5372 16.9158 20.946 16.38C20.355 15.8444 19.5561 15.409 18.6548 15.0656L17.9426 16.9344ZM4 18.5C4 18.3898 4.05435 18.1725 4.39705 17.862C4.73994 17.5512 5.29175 17.2262 6.05741 16.9344L5.34521 15.0656C4.44387 15.409 3.64503 15.8444 3.05401 16.38C2.46281 16.9158 2 17.6308 2 18.5H4Z",
  fill: "currentColor"
});

function SvgLocationPin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPin);
export default __webpack_public_path__ + "static/media/locationPin.065a17f3.svg";
export { ForwardRef as ReactComponent };